import React from "react";

import RaisedButton from "material-ui/RaisedButton";

import { reduxForm, formValueSelector } from "redux-form";
import validate from "./validate";
import FullscreenDialog from "material-ui-fullscreen-dialog";

import fetchClient from "../../components/utils/fetchClient";

import { DragDrop, StatusBar } from "@uppy/react";
import Uppy from "@uppy/core";
import AwsS3 from "@uppy/aws-s3";
import "@uppy/core/dist/style.css";
import "@uppy/status-bar/dist/style.css";

import { connect } from "react-redux";

class PrepForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentImage: "",
            modal_open: false
        };
    }

    componentWillMount() {
        this.preppic = new Uppy({ id: "prep", autoProceed: true })
            .use(AwsS3, {
                getUploadParameters(file) {
                    return fetchClient
                        .post(
                            "upload",
                            JSON.stringify({
                                destination: "prep",
                                upload_type: "prep",
                                filename: file.name,
                                contentType: file.type
                            })
                        )
                        .then(response => {
                            return response.data;
                        })
                        .then(data => {
                            return {
                                method: data.method,
                                url: data.url,
                                fields: data.fields,
                                resultId: data.resultId
                            };
                        });
                }
            })
            .on("upload-success", (file, resp, uploadURL) => {
                var self = this;
                fetchClient
                    .post("store", { id: self.props.bookingId, type: "prep", url: uploadURL })
                    .then(function (response) {
                        self.props.change("prepPic", uploadURL);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            });
    }

    componentWillUnmount() {
        this.preppic.close();
    }

    showModal(image) {
        if (image) {
            this.setState({ currentImage: image, modal_open: true });
        }
    }

    render() {
        const { handleSubmit, invalid, prepPic } = this.props;

        return (
            <form onSubmit={handleSubmit} style={{ marginLeft: 5, marginBottom: 5 }}>
                <div>
                    <h3>Basket + Map + Note</h3>

                    <DragDrop
                        locale={{
                            strings: {
                                dropHereOr: "Upload image or %{browse}",
                                browse: "browse"
                            }
                        }}
                        uppy={this.preppic}
                    />
                    <StatusBar uppy={this.preppic} hideUploadButton hideAfterFinish={false} showProgressDetails />

                    {prepPic ? (
                        <div>
                            <br />
                            <RaisedButton label="View Image" disableTouchRipple={true} disableFocusRipple={true} onClick={() => this.showModal(prepPic)} />
                        </div>
                    ) : null}
                </div>

                <FullscreenDialog
                    open={this.state.modal_open}
                    onRequestClose={(...args) => {
                        this.setState({ modal_open: false });
                    }}
                    title="View Image"
                >
                    <div style={{ paddingLeft: 15, paddingTop: 15, paddingRight: 15 }}>
                        <img style={{ width: "100%", height: "auto" }} src={this.state.currentImage} alt="Prep" />
                    </div>
                </FullscreenDialog>

                <div>
                    <div style={{ marginTop: 15 }}>
                        <RaisedButton label="Next" disableTouchRipple={true} disableFocusRipple={true} primary={true} disabled={invalid} type="submit" />
                    </div>
                </div>
            </form>
        );
    }
}

PrepForm = reduxForm({
    form: "precheckinform",
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate
})(PrepForm);

const selector = formValueSelector("precheckinform");

PrepForm = connect(state => {
    const { prepPic, bookingId } = selector(state, "prepPic", "bookingId");
    return {
        prepPic,
        bookingId
    };
})(PrepForm);

export default PrepForm;
